<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<div class="navbar navbar-expand-lg">
					<!-- Page title -->
					<loading type="header" v-if="editClass.loaded == 0" />
					<div v-if="editClass.loaded != 0" class="navbar-text nav-title flex" id="pageTitle">
						{{ editClass.name }}
					</div>
				</div>

				<div class="content-main" style="background-color:white">
					<!-- Page content goes here -->
					<div class="h-100" v-if="editClass.loaded != 0">
						<div class="d-sm-flex b-t h-100">
							<edit-pane :cancel="loadData" :save="saveClass" :dirty="dirty" :valid="valid">
								<div class="p-4 b-b _600 nav-title">Class Details</div>
								<div class="col-sm-10 col-12">
									<div class="row m-0 pt-4">
										<div class="col-sm-6 col-12">
											<div class="form-group" :class="{ invalid: !valid.field('name') }">
												<label>Class Name</label>
												<input type="text" class="form-control" v-model="editClass.name" />
											</div>
										</div>
										<div class="form-group col-sm-6 col-12">
											<label>Team</label>
											<v-select :options="teams" v-model="sTeam" label="name" disabled></v-select>
										</div>
									</div>
									<div class="row m-0 pt-4">
										<div
											class="form-group col-sm-6 col-12"
											:class="{ invalid: !valid.field('district') }"
										>
											<label>District</label>
											<v-select :options="districts" v-model="sDistrict" label="name"></v-select>
										</div>
										<div
											class="form-group col-sm-6 col-12"
											:class="{ invalid: !valid.field('school') }"
										>
											<label>School</label>
											<v-select :options="schools" v-model="sSchool" label="name"></v-select>
										</div>
									</div>
									<div class="row m-0 pt-4">
										<div class="form-group col-sm-6 col-12">
											<label>Course</label>
											<v-select :options="courses" @input="updateCourseID" v-model="sCourse" label="name"></v-select>
										</div>
									</div>
									<div class="row m-0 pt-4">
										<div class="col-12 col-sm-6">
											<div class="card shadow px-3 py-2">
												<template v-if="!students">
													<h4 class="mb-0"><i class="fas fa-user mr-2" />Students</h4>
												</template>
												<template v-if="students && loadingStudents">
													<h4 class="mb-0">
														<i class="fas fa-user mr-2" />Students
														<loading
															type="icon"
															class="ml-2"
															style="margin-bottom: -2px;"
														/>
													</h4>
												</template>
												<div
													v-if="students && !loadingStudents"
													class="d-flex flex-row align-items-center"
												>
													<h4 class="flex mb-0">
														<i class="fas fa-user mr-2" />Students
														<span class="text-muted text-md">({{ students.length }})</span>
													</h4>
													<!-- TODO: Implement add student and add teacher modals -->
													<button
														class="btn btn-sm btn-icon btn-subtle text-white"
														style="margin-top: -4px; margin-right: 10px;"
														v-tippy
														title="Add"
														data-toggle="modal"
														data-target="#addStudentModal"
													>
														<i class="text-primary far fa-2x fa-plus"></i>
													</button>
												</div>
												<hr class="mt-2" />
												<loading
													v-if="loadingStudents && !students"
													type="medium"
													class="text-center"
												/>
												<h4
													v-if="students && students.length == 0 && !loadingStudents"
													class="text-very-muted text-center mt-2 mb-3"
												>
													None
												</h4>

												<template v-if="students && students.length > 0">
													<div
														v-for="student in students"
														:key="student.id"
														class="student-row card mb-2 mx-2 py-1 px-2 d-flex flex-row align-items-center"
													>
														<div class="flex break-words">
															<span class>{{ student.full_name }}</span>
															<span v-if="student.email" class="text-muted"
																>({{ student.email }})</span
															>
														</div>
														<button
															class="btn btn-sm btn-icon btn-subtle text-white ml-2"
															v-tippy
															title="Remove"
															@click="removeStudent(student)"
														>
															<i class="text-danger far fa-lg fa-trash"></i>
														</button>
													</div>
												</template>

												<div v-if="students && loadingStudents" class="loading-overlay"></div>
											</div>
										</div>
										<div class="col-12 col-sm-6">
											<div class="card shadow px-3 py-2">
												<template v-if="!owners">
													<h4 class="mb-0"><i class="fas fa-users mr-2" />Teachers</h4>
												</template>
												<template v-if="owners && loadingOwners">
													<h4 class="mb-0">
														<i class="fas fa-users mr-2" />Teachers
														<loading
															type="icon"
															class="ml-2"
															style="margin-bottom: -2px;"
														/>
													</h4>
												</template>
												<div
													v-if="owners && !loadingOwners"
													class="d-flex flex-row align-items-center"
												>
													<h4 class="flex mb-0">
														<i class="fas fa-users mr-2" />Teachers
														<span class="text-muted text-md">({{ owners.length }})</span>
													</h4>
													<button
														class="btn btn-sm btn-icon btn-subtle text-white"
														style="margin-top: -4px; margin-right: 10px;"
														v-tippy
														title="Add"
														data-toggle="modal"
														data-target="#addTeacherModal"
													>
														<i class="text-primary far fa-2x fa-plus"></i>
													</button>
												</div>
												<hr class="mt-2" />
												<loading
													v-if="loadingOwners && !owners"
													type="medium"
													class="text-center"
												/>
												<h4
													v-if="owners && owners.length == 0 && !loadingOwners"
													class="text-very-muted text-center mt-2 mb-3"
												>
													None
												</h4>

												<template v-if="owners && owners.length > 0">
													<div
														v-for="owner in owners"
														:key="owner.id"
														class="teacher-row card mb-2 mx-2 py-1 px-2 d-flex flex-row align-items-center"
													>
														<div class="flex break-words">
															<span class>{{ owner.full_name }}</span>
															<span class="text-muted">({{ owner.email }})</span>
														</div>
														<button
															class="btn btn-sm btn-icon btn-subtle text-white ml-1"
															v-tippy
															title="Remove"
															@click="removeTeacher(owner)"
														>
															<i class="text-danger far fa-lg fa-trash"></i>
														</button>
													</div>
												</template>

												<div v-if="owners && loadingOwners" class="loading-overlay"></div>
											</div>
										</div>
									</div>
								</div>
							</edit-pane>
							<save-optional-modal
								:dirty="dirty"
								:valid="valid"
								:save="saveClass"
								:next="saveOptNext"
								:cancel="saveOptCancel"
								objectText="User"
								:objectName="user.first_name + ' ' + user.last_name"
								actionText="leave the page"
								v-model="saveOptModal"
							/>
						</div>
					</div>

					<div class="modal" id="addTeacherModal" data-backdrop="static" data-keyboard="false">
						<div class="modal-dialog modal-lg">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="mb-0">Add Teachers</h5>
								</div>
								<div class="modal-body">
									<div class="px-2 py-0">
										<div class="form-group">
											<label>Search teachers...</label>
											<input
												type="text"
												class="form-control shadow-sm"
												v-model="teacherFilter"
												@input="searchTeachers()"
											/>
										</div>
									</div>

									<hr class="mt-2" style="margin-left: -24px; width: calc(100% + 48px)" />

									<div class="position-relative" style="min-height: 428px;">
										<h3
											v-if="
												(!searchedTeachers || searchedTeachers.length == 0) &&
													!searchingTeachers
											"
											class="text-very-muted text-center pt-4 mb-0"
										>
											No matching teachers
										</h3>

										<template v-if="searchedTeachers && searchedTeachers.length > 0">
											<div
												v-for="teacher in searchedTeachers"
												:key="teacher.id"
												class="teacher-row card mt-1 py-1 px-2 d-flex flex-row align-items-center"
												:class="{
													'text-extra-muted': editClass.owner_ids.includes(teacher.id)
												}"
											>
												<div class="flex break-words">
													<div>{{ teacher.full_name }}</div>
													<div class="text-muted text-xxs">{{ teacher.email }}</div>
												</div>
												<button
													v-if="!editClass.owner_ids.includes(teacher.id)"
													class="btn btn-sm btn-icon btn-subtle text-white ml-2 mr-0"
													v-tippy
													title="Add"
													@click="addTeacher(teacher)"
												>
													<i class="text-primary far fa-2x fa-plus"></i>
												</button>
												<i
													v-if="editClass.owner_ids.includes(teacher.id)"
													class="text-secondary text-muted far fa-2x fa-check"
													v-tippy
													title="In this class"
												></i>
											</div>
										</template>

										<div v-if="searchingTeachers" class="loading-overlay">
											<loading type="page" class="text-center" />
										</div>
									</div>
								</div>
								<div class="modal-footer">
									<button class="btn btn-flat theme" @click="hideAddTeacherModal">Done</button>
								</div>
							</div>
						</div>
					</div>

					<div class="modal" id="addStudentModal" data-backdrop="static" data-keyboard="false">
						<div class="modal-dialog modal-lg">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="mb-0">Add Students</h5>
								</div>
								<div class="modal-body">
									<div v-if="district">
										<div>
											<label>Search</label>
											<config-student-search
												v-model="studentSearch"
												:districtID="editClass.district_id"
											/>
										</div>
									</div>
									<div class="clickable-links d-flex flex-row justify-content-end text-extra-muted">
										<a href="/static/templates/Class Roster Template - Add Students to Class.csv" download>
											Download template...
										</a>
									</div>
									<div
										class="dropzone clickable p-3 card"
										:class="{ dropping: droppingFile }"
										@drop.prevent="doDropStudentFiles"
										@dragenter="addDropStudentFiles"
										@dragleave="removeDropStudentFiles"
										@dragover.prevent
										@click="click('file-input')"
									>
										<input
											id="file-input"
											class="d-none"
											type="file"
											accept=".csv"
											@change="selectImportFile"
										/>
										<h3 class="text-very-muted text-center my-4 no-pointer">
											{{ droppingFile ? "Release to upload..." : "Drag or click to upload..." }}
										</h3>
									</div>
									<hr class="modal-divider" />
									<div class="form-group">
										<label>Add</label>
										<div v-for="(student, i) in addingStudents" :key="i">
											<div v-if="!student.exists">
												<div class="d-flex flex-row align-items-center">
													<!-- Validation alerts -->
													<a
														v-if="student.match"
														class="btn-subtle mr-1 student-alert-btn"
														v-tippy
														:title="
															`Matched existing student.<br />Click here if you would like to create a duplicate student with the same name.`
														"
														@click="convertToNewStudent(student)"
													>
														<i
															class="fas fa-user-check fa-lg text-success"
															style="margin-left: 2px;"
														/>
													</a>
													<a
														v-if="student.partial_name && student.partial_name.exists"
														class="btn-subtle mr-1 student-alert-btn"
														v-tippy
														:title="
															`A student named '${student.first_name} ${student.last_name}' is already enrolled in this class with ID '${student.partial_name.ref_id}'.<br />Edit the information, or click here to remove this row.`
														"
														@click="removeStudentRow(i)"
													>
														<i
															class="fas fa-exclamation-circle fa-lg text-warning error-icon"
														/>
													</a>
													<a
														v-if="student.partial_name && !student.partial_name.exists"
														class="btn-subtle mr-1 student-alert-btn"
														v-tippy
														:title="
															`A student named '${student.first_name} ${student.last_name}' already exists with ID '${student.partial_name.ref_id}'.<br />Click here to use the existing student.`
														"
														@click="convertToExistingStudent(student, student.partial_name)"
													>
														<i
															class="fas fa-exclamation-circle fa-lg text-warning error-icon"
														/>
													</a>
													<a
														v-if="student.partial_id"
														class="btn-subtle mr-1 student-alert-btn"
														v-tippy
														:title="
															`A student with ID '${student.ref_id}' already exists as '${student.partial_id.first_name} ${student.partial_id.last_name}'.<br />Click here to use the existing student.`
														"
														@click="convertToExistingStudent(student, student.partial_id)"
													>
														<i
															class="fas fa-exclamation-circle fa-lg text-danger error-icon"
														/>
													</a>
													<div
														v-if="
															!(
																student.match ||
																student.partial_name ||
																student.partial_id
															)
														"
														class="mr-1 student-alert-btn"
													>
														<i
															v-if="!(validated && allValid && !adding)"
															class="fas fa-user fa-lg text-very-muted"
														/>
														<i
															v-if="validated && allValid && !adding"
															class="fas fa-user-check fa-lg text-very-muted"
															style="margin-left: 2px;"
														/>
													</div>

													<!-- Input fields -->
													<input
														@input="changedStudentName(student)"
														class="form-control"
														style="flex-basis: 20%; height: 36px;"
														placeholder="First name"
														v-model="student.first_name"
														:disabled="hasID(student)"
													/>
													<input
														@input="changedStudentName(student)"
														class="form-control"
														style="flex-basis: 20%; height: 36px;"
														placeholder="Last name"
														v-model="student.last_name"
														:disabled="hasID(student)"
													/>
													<input
														@input="changedStudentID(student)"
														class="form-control"
														style="flex-basis: 20%; height: 36px;"
														placeholder="Student ID"
														v-model="student.ref_id"
														:disabled="hasID(student)"
													/>
													<input
														@input="changedStudent(student)"
														class="form-control"
														style="flex-basis: 28%; height: 36px;"
														:placeholder="
															district && district.require_emails
																? 'Email'
																: 'Email (optional)'
														"
														v-model="student.email"
														:disabled="hasID(student)"
													/>
													<div class="ml-2" style="flex-basis: 80px;">
														<button
															class="btn btn-sm btn-icon btn-rounded danger"
															@click="removeStudentRow(i)"
														>
															<i class="fas fa-minus" />
														</button>
														<button
															v-if="i == addingStudents.length - 1"
															class="btn btn-sm btn-icon btn-rounded success"
															@click="addStudentRow(i)"
														>
															<i class="fas fa-plus" />
														</button>
													</div>
												</div>
												<div v-if="student.error" class="d-flex flex-row align-items-center">
													<i class="fas fa-exclamation-triangle text-danger error-icon" />
													{{ student.error }}
												</div>
											</div>
										</div>
										<div v-for="(student, i) in addingStudents" :key="i">
											<div v-if="student.exists">
												<i class="fas fa-exclamation-circle error-icon" />
												{{ student.first_name }} {{ student.last_name }} is already part of this
												class
											</div>
										</div>
									</div>
								</div>
								<div class="modal-footer">
									<div v-show="validated && !allValid" class="flex">
										You must resolve all issues marked with
										<i class="fas fa-exclamation-triangle text-danger error-icon mr-0" />
										before you can continue.
									</div>

									<button class="btn btn-flat" @click="hideAddStudentModal">Cancel</button>
									<button
										v-show="!validated && !validating"
										class="btn btn-flat theme"
										@click="validateStudents"
									>
										Validate
									</button>
									<button v-show="!validated && validating" class="btn btn-flat theme" disabled>
										Validating...
										<loading type="icon" />
									</button>
									<button
										v-show="validated && allValid && !adding"
										class="btn btn-flat btn-success"
										@click="doAddStudents"
										:disabled="!anyStudents"
									>
										Add
									</button>
									<button v-show="validated && !allValid" class="btn btn-flat btn-secondary" disabled>
										Add
									</button>
									<button v-show="adding" class="btn btn-flat btn-success" disabled>
										Adding...
										<loading type="icon" />
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<mzfooter></mzfooter>
	</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}
</style>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ConfigSelect from "@/components/ConfigSelect";
import ConfigStudentSearch from "@/components/ConfigStudentSearch";
import UserService from "@/services/UserService";
import ClassService from "@/services/ClassService";
import StudentService from "@/services/StudentService";
import TenantService from "@/services/TenantService";
import SchoolService from "@/services/SchoolService";
import CourseService from "@/services/CourseService";
import TeamService from "@/services/TeamService";
import ContentAreaService from "@/services/ContentAreaService";
import GradeService from "@/services/GradeService";
import DistrictService from "@/services/DistrictService";
import ValidationService from "@/services/ValidationService";
import notie from "@/services/NotieService";
import Utils from "@/services/Utils";
import fs from "@/services/FormatService";
import $ from "jquery";
import BB from "bluebird";
export default {
	name: "ClassEdit",
	props: ["user", "params", "query"],
	components: { EditPane, SaveOptionalModal, ConfigSelect, ConfigStudentSearch },
	data() {
		return {
			tab: 1,
			editClass: {
				name: null,
				district_id: null,
				school_id: null,
				student_ids: [],
				owner_ids: [],
				course_id : null
			},
			owners: [],
			loadingOwners: false,
			students: [],
			loadingStudents: false,
			teacherFilter: null,
			searchingTeachers: false,
			searchedTeachers: null,
			studentSearch: null,
			addingStudents: [{}],
			searchedStudents: null,
			droppingFile: false,
			validating: false,
			validated: false,
			allValid: false,
			adding: false,
			teams: [],
			sTeam: null,
			roles: [],
			sRole: null,
			areas: [],
			sAreas: null,
			grades: [],
			sGrades: null,
			district: null,
			districts: [],
			sDistrict: null,
			courses: [],
			sCourse: null,
			schools: null,
			sSchool: null,
			dirty: false,
			valid: {},
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {}
		};
	},
	computed: {
		accessibleRoles() {
			return _.filter(this.roles, role => {
				return this.user.role.access >= role.access;
			});
		},
		anyStudents() {
			let any = false;
			_.each(this.addingStudents, s => {
				if (!s.exists && (s.first_name || s.last_name || s.ref_id)) {
					any = true;
				}
			});
			return any;
		},
		sAreaIDs() {
			return _.map(this.sAreas, "id");
		},
		sGradeIDs() {
			return _.map(this.sGrades, "id");
		},
		sDistrictID() {
			return (this.sDistrict && this.sDistrict.id) || null;
		},
		sSchoolID() {
			return (this.sSchool && this.sSchool.id) || null;
		},
		sTeamID() {
			return (this.sTeam && this.sTeam.id) || null;
		}
	},
	watch: {
		sDistrictID(newVal) {
			let oldVal = this.editClass.district_id;
			if (newVal != oldVal) {
				this.editClass.district_id = newVal;
			}
			SchoolService.listSchools({
				district_id: this.editClass.district_id
			}).then(r => {
				this.schools = r.data.schools;
				let matchSchool = _.find(this.schools, {
					id: this.editClass.school_id
				});
				this.sSchool = matchSchool;
			});
			CourseService.getCourses({
				district_id: this.editClass.district_id
			}).then(r => {
				this.courses = r.data.courses;
				let matchCourse = _.find(this.courses, {
					id: this.editClass.course_id
				});
				this.sCourse = matchCourse;
			});
		},
		sSchoolID(newVal) {
			let oldVal = this.editClass.district_id;
			if (newVal != oldVal) {
				this.editClass.school_id = newVal;
			}
		},
		studentSearch() {
			if (this.studentSearch) {
				this.clearEmptyStudentRows();
				let exists = _.find(this.addingStudents, {
					id: this.studentSearch.id
				});
				if (!exists) {
					this.addingStudents.push(this.studentSearch);
					this.studentSearch = null;
				}
			}
		}
	},
	created() {
		this.loadData();
		this.initValidation();
		if (this.query.tab) {
			this.tab = this.query.tab;
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},
	methods: {		
		
		updateCourseID(course) {
			this.editClass.course_id = course.id;
			console.log(this.dirty)
		},
		initValidation() {
			this.valid = ValidationService.newValidator({
				name: {
					group: "details",
					errorMsg: "You must assign a name",
					func: () => {
						return this.editClass && this.editClass.name;
					}
				},
				district: {
					group: "details",
					errorMsg: "You must choose a district",
					func: () => {
						return this.editClass && this.editClass.district_id;
					}
				},
				school: {
					group: "details",
					errorMsg: "You must choose a school",
					func: () => {
						return this.editClass && this.editClass.school_id;
					}
				}
			});
		},
		blankUser() {
			return {
				team_id: null,
				role_id: null,
				role: null,
				setPass: false,
				password: null,
				password2: null
			};
		},
		watchChanges() {
			if (this.unwatch) {
				this.unwatch();
			}
			this.unwatch = this.$watch(
				"editClass",
				(newc, old) => {
					console.log(newc);
					console.log("marking dirty");
					this.dirty = true;
				},
				{ deep: true }
			);
		},
		loadData() {
			this.dirty = false;
			var loaded = this.editClass.loaded;
			loaded++;
			if (this.params.id != "new") {
				return BB.props({
					class: ClassService.getClass(this.params.id),
					client: TenantService.getClient("current"),
					teams: TeamService.listTeams(),
					contentAreas: ContentAreaService.listContentAreas(),
					grades: GradeService.listGrades(),
					districts: DistrictService.listDistricts({ noempty: true })
				})
					.then(resps => {
						this.editClass = resps.class.data;
						this.editClass.loaded = loaded;
						this.loadingOwners = true;
						this.loadingStudents = true;
						this.owners = [];
						this.students = [];
						//TODO: make service to pass in array to that only 1 mongo connection is made
						_.each(this.editClass.owner_ids, (ownerID, i, list) => {
							UserService.getUser(ownerID)
								.then(res => {
									this.owners.push(res.data);
								})
								.catch(err => {
									console.log(err);
								});
						});
						this.loadingOwners = false;
						StudentService.listStudentsFromClass(this.editClass.id)
							.then(res => {
								this.students = res.data.students;
								this.loadingStudents = false;
							})
							.catch(err => {
								console.log(err);
							});
						DistrictService.getDistrict(this.editClass.district_id)
							.then(res => {
								this.district = res.data;
							})
							.catch(err => {
								console.log(err);
							});
						this.roles = resps.client.data.roles;
						if (this.roles.length > 0 && this.editUser) {
							if (this.editUser.role) {
								this.sRole = _.find(this.roles, {
									id: this.editUser.role.id
								});
							} else {
								this.sRole = null;
							}
						}
						this.teams = resps.teams.data.teams;
						if (this.teams && this.teams.length > 0 && this.editClass) {
							if (this.editClass.team_id) {
								this.sTeam = _.find(this.teams, {
									id: this.editClass.team_id
								});
							} else {
								this.sTeam = null;
							}
						}
						this.sAreas = [];
						this.areas = resps.contentAreas.data.content_areas;
						if (this.areas && this.areas.length > 0 && this.editUser) {
							_.each(this.editUser.content_area_ids, caid => {
								let area = _.find(this.areas, {
									id: caid
								});
								if (area) {
									this.sAreas.push(area);
								}
							});
						}
						this.sGrades = [];
						this.grades = resps.grades.data;
						if (this.grades && this.grades.length > 0 && this.editUser) {
							_.each(this.editUser.grade_ids, gid => {
								let grade = _.find(this.grades, {
									id: gid
								});
								if (grade) {
									this.sGrades.push(grade);
								}
							});
						}
						this.districts = resps.districts.data.districts;
						if (this.districts && this.districts.length > 0 && this.editClass) {
							if (this.editClass.district_id) {
								this.sDistrict = _.find(this.districts, {
									id: this.editClass.district_id
								});
							} else {
								this.sDistrict = null;
							}
						}
						this.watchChanges();
					})
					.catch(err => {
						console.log(err);
						notie.error("Error loading user", err);
					});
			} else {
				return BB.props({
					client: TenantService.getClient("current"),
					contentAreas: ContentAreaService.listContentAreas(),
					districts: DistrictService.listDistricts(),
					grades: GradeService.listGrades()
				})
					.then(resps => {
						this.roles = resps.client.data.roles;
						this.sAreas = [];
						this.areas = resps.contentAreas.data.content_areas;
						this.sGrades = [];
						this.grades = resps.grades.data;
						this.districts = resps.districts.data.districts;
						this.editUser = this.blankUser();
						this.editUser.loaded = loaded;
						this.editUser.first_name = "New";
						this.editUser.last_name = "User";
						this.watchChanges();
					})
					.catch(err => {
						console.log(err);
						notie.error("Error loading user", err);
					});
			}
		},
		showValidationHints() {
			this.validationHints = true;
		},
		getValidationErrors() {
			let errors = [];
			_.each(this.validators, va => {
				if (!va.func()) {
					errors.push(va.errorMsg);
				}
			});
			return errors;
		},
		saveClass() {
			this.editClass.team_id = this.owners[0].team_id;
			let saveClass = _.cloneDeep(this.editClass);
			delete saveClass.client;
			delete saveClass.role;
			return ClassService.saveClass(saveClass)
				.then(resp => {
					notie.info("Class Saved");
					if (this.editClass.id != resp.data.id) {
						this.$router.replace(`/admin/classes/${resp.data.id}`);
					}
					this.loadData();
				})
				.catch(err => {
					console.log(err.response);
					notie.error(`Failed to save class`, err);
				});
			this.user.teams = dontSendTeams;
		},
		canSave() {
			return this.dirty;
		},
		searchTeachers() {
			if (this.teacherFilter) {
				this.searchingTeachers = true;
				this.doSearchTeacher(this.teacherFilter, this);
			} else {
				this.searchedTeachers = [];
			}
		},
		doSearchTeacher: _.debounce((filter, _this) => {
			let ctx = {
				perPage: 8,
				currentPage: 1,
				filter: filter,
				role: "!STUDENT"
			};
			if (_this.editClass.district_id) {
				ctx.district_id = _this.editClass.district_id;
			}
			if (_this.editClass.team_id) {
				ctx.team_id = _this.editClass.team_id;
			} else {
				ctx.team_id = "none";
			}
			UserService.listUsers(ctx)
				.then(resp => {
					_this.searchingTeachers = false;
					_this.searchedTeachers = resp.data.users;
					_.each(_this.searchedTeachers, st => {
						if (_this.editClass.owner_ids.includes(st.id)) {
							st.inClass = true;
						}
					});
				})
				.catch(e => {
					this.searchingTeachers = false;
					console.log(e);
					notie.error("Failed to load teachers", e);
				});
		}, 250),
		addTeacher(teacher) {
			this.owners.push(teacher);
			this.editClass.owner_ids.push(teacher.id);
		},
		removeTeacher(teacher) {
			let i = this.editClass.owner_ids.indexOf(teacher.id);
			if (!(i >= 0 && this.owners[i] && this.owners[i].id == this.editClass.owner_ids[i])) {
				notie.error("Failed to remove teacher", "Data error, please refresh the page");
				return;
			}
			this.$delete(this.editClass.owner_ids, i);
			this.$delete(this.owners, i);
		},
		removeStudent(student) {
			let i = this.editClass.student_ids.indexOf(student.id);
			if (!(i >= 0 && this.students[i] && this.students[i].id == this.editClass.student_ids[i])) {
				notie.error("Failed to remove student", "Data error, please refresh the page");
				return;
			}
			this.$delete(this.editClass.student_ids, i);
			this.$delete(this.students, i);
		},
		addDropStudentFiles(event) {
			console.log("___FILE ENTER___");
			console.log(event.dataTransfer.files);
			this.droppingFile = true;
		},
		removeDropStudentFiles(event) {
			console.log("___FILE LEAVE___");
			console.log(event.dataTransfer.files);
			this.droppingFile = false;
		},
		doDropStudentFiles(event) {
			console.log("___FILE DROP___");
			console.log(event.dataTransfer.files);
			_.each(event.dataTransfer.files, file => {
				this.importStudentRows(file);
			});
			this.droppingFile = false;
		},
		importStudentRows(file) {
			if (file.type != "text/csv" && file.type != "application/vnd.ms-excel") {
				this.importingFile = null;
				notie.error("File must be CSV!");
				return;
			}
			let reader = new FileReader();
			reader.onload = e => {
				let studentsIn = FileService.CSVToArray(e.target.result);
				let students = [];
				for (var i = 1; i < studentsIn.length; i++) {
					let studentIn = studentsIn[i];
					let grade = _.find(this.grades, { name: studentIn[3] });
					grade = grade || this.grades[0];
					let student = {
						first_name: studentIn[0],
						last_name: studentIn[1],
						ref_id: studentIn[2],
						email: studentIn[4],
						grade: grade,
						grade_id: grade.id
					};
					console.log("add student", student);
					if (student.first_name || student.last_name || student.ref_id) {
						students.push(student);
					}
				}
				this.validateStudents(students);
			};
			reader.readAsText(file);
		},
		validateStudents(newStudents) {
			this.clearEmptyStudentRows();
			let students = _.cloneDeep(this.addingStudents);
			if (newStudents && newStudents.length) {
				students = students.concat(newStudents);
			}
			_.each(students, s => {
				s.grade_id = s.grade && s.grade.id;
			});
			let did = this.editClass.district_id;
			this.validating = true;
			this.allValid = true;
			StudentService.getStudentMatches(students, did).then(resp => {
				this.addingStudents = [];
				_.each(resp.data, matchStat => {
					let student = matchStat.student;
					let existing = _.find(this.students, {
						id: student.id
					});
					if (existing) {
						student.exists = true;
					}
					student.match = matchStat.match;
					if (matchStat.partial_name) {
						student.partial_name = matchStat.partial_name;
						let existing = _.find(this.students, {
							id: student.partial_name.id
						});
						if (existing) {
							student.partial_name.exists = true;
						}
					}
					if (matchStat.partial_id) {
						student.partial_id = matchStat.partial_id;
						console.log("partial id", student);
						this.allValid = false;
					}
					student.grade = _.find(this.grades, {
						id: student.grade_id
					});
					if (!student.ref_id || student.ref_id == "") {
						student.error = "You must enter a student ID";
						console.log("no id", student);
						this.allValid = false;
					} else if (this.district.id_regex && !this.district.id_regex.exec(student.ref_id)) {
						student.error = `Student ID does not match this district's required pattern ("${this.district.validation_pattern}")`;
						console.log("invalid id", student);
						this.allValid = false;
					} else if (!student.first_name || !student.last_name) {
						student.error = "You must enter a name";
						console.log("no name", student);
						this.allValid = false;
					} else if (this.district.require_emails && !student.email) {
						student.error = "You must enter an email address";
						console.log("email address", student);
						this.allValid = false;
					}
					this.clearEmptyStudentRows();
					this.addingStudents.push(student);
					this.validating = false;
					this.validated = true;
				});
			});
		},
		clearEmptyStudentRows(clearAll) {
			this.addingStudents = _.filter(this.addingStudents, s => {
				return s.first_name || s.last_name || s.id || s.grade;
			});
		},
		hasID(student) {
			if (student.id && student.id != "") {
				return true;
			} else {
				return false;
			}
		},
		selectImportFile(event) {
			console.log("===CHOOSE FILE===");
			console.log(event.target.files);
			if (event.target.files[0]) {
				this.importingFile = event.target.files[0];
				this.importStudentRows(this.importingFile);
			}
		},
		hideAddTeacherModal() {
			$("#addTeacherModal").modal("toggle");
		},
		hideAddStudentModal() {
			this.addingStudents = [{}];
			this.validated = false;
			this.allValid = false;
			$("#addStudentModal").modal("toggle");
		},
		click(id) {
			console.log("click the thing");
			var el = document.getElementById(id);
			if (el) {
				el.value = "";
				el.click();
			}
		},
		doAddStudents() {
			this.clearEmptyStudentRows();
			_.each(this.addingStudents, student => {
				student.district_id = this.editClass.district_id;
				student.client_id = this.editClass.client_id;
			});
			ClassService.saveStudentsToClass(this.editClass.id, this.addingStudents)
				.then(resp => {
					let count = resp.data;
					notie.info(`${count} ${count > 1 ? "students" : "student"} saved`);
					this.addingStudents = [{}];
					this.loadData().then(() => {
						$("#addStudentModal").modal("toggle");
					});
				})
				.catch(err => {
					console.log(err);
					notie.error("Failed to save student(s)", err);
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/ClassEdit.vue